// extracted by mini-css-extract-plugin
export default {"box":"category_box__Jd6tj"};